import { IconButton, Badge } from '@material-ui/core';
import React from 'react';
import NotificationsNoneOutlinedIcon from '@material-ui/icons/NotificationsNoneOutlined';
import clsx from 'clsx';
import useStyles from '../styles';
import { requiredLogin } from '../../../../middlewares';
import AppButton from 'components/atoms/Button';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';

const AddNewButton = () => {
  const classes = useStyles({});
  return (
    <AppButton
      variant="contained"
      color="secondary"
      style={{ marginLeft: '1rem', marginRight: '1rem' }}
      text={<TranslatedTextV2 translationKey="" defaultText="Add new" />}
      startIcon={<AddCircleOutlineRoundedIcon />}
    />
  );
};

export default requiredLogin(AddNewButton);
